import useApi from "@/hooks/api/useApi";
import useApiEnvState from "@/hooks/api-env/useApiEnvState";

interface ResponseAdmin {
  isAdmin: boolean;
}

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-cef4eedb-0962-459f-beda-5780a4e1199f?active-environment=872654bd-7e32-419c-bbb3-44f2586a21dc
 */
export default function useAdmin() {
  const [apiEnv] = useApiEnvState();
  const { data, isLoading, isError, mutate } = useApi<ResponseAdmin, ResponseAdmin>(
    {
      path: "/admin/",
      api: "v2",
      useJwt: true,
      params: {
        apiEnv,
      },
    },
    {
      strategy: "fully-cached",
    }
  );

  return {
    data,
    isLoading,
    isError,
    mutate,
  };
}
